import React from 'react'

import { createValidIcon } from '@ui/icons/utils/type-helper'

import styles from './Card.module.scss'

export const TroyCard = createValidIcon(() => {
  return (
    <svg
      className={styles.cardShadow}
      width='36'
      height='24'
      viewBox='0 0 36 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M0 4C0 1.79086 1.79086 0 4 0H32C34.2091 0 36 1.79086 36 4V20C36 22.2091 34.2091 24 32 24H4C1.79086 24 0 22.2091 0 20V4Z'
        fill='white'
      />
      <path
        d='M7.99269 6C8.62605 6 8.93218 6.25386 8.82135 6.8885L8.63662 7.92507H10.0934L9.77141 9.74966H8.31464L7.91879 12.0079C7.78157 12.7959 8.55745 12.8964 9.0008 12.8964C9.09052 12.8964 9.16441 12.8964 9.2172 12.8964L8.85828 14.9273C8.70524 14.9431 8.55217 14.9537 8.39381 14.9537C7.28542 14.9537 5.19529 14.6576 5.60698 12.32L6.05562 9.75496H5L5.32196 7.93036H6.37231L6.7101 6.00529H7.99269V6Z'
        fill='#4C565C'
      />
      <path
        d='M20.2274 8.0097L19.8526 10.1357C20.5546 10.4901 20.8291 11.3521 20.4754 12.0502C20.259 12.4733 19.8526 12.7589 19.3828 12.8171L19.0081 14.9431C19.0767 14.9431 19.1401 14.9484 19.2087 14.9484C21.1616 14.9484 22.745 13.3618 22.745 11.405C22.745 9.83957 21.7211 8.46453 20.2274 8.0097Z'
        fill='#24B8C9'
      />
      <path
        d='M18.5647 12.6743C17.8627 12.32 17.5883 11.4632 17.9419 10.7598C18.1583 10.3367 18.5647 10.0511 19.0398 9.99294L19.4145 7.8669C19.3459 7.8669 19.2825 7.86161 19.2139 7.86161C17.261 7.86161 15.6776 9.44821 15.6776 11.405C15.6776 12.9705 16.7015 14.3508 18.1953 14.8003L18.5647 12.6743Z'
        fill='#24B8C9'
      />
      <path
        d='M10.9379 7.93036H12.1888C12.8221 7.93036 13.1283 8.18422 13.0174 8.81885L12.8802 9.591C13.3447 8.60203 14.3053 7.94094 15.3979 7.86161C15.4876 7.86161 15.5773 7.87219 15.667 7.88806L15.2606 10.1833C15.1076 10.1516 14.9545 10.141 14.7961 10.141C13.9464 10.1146 13.1599 10.5906 12.7905 11.3574C12.6532 11.6589 12.553 11.9762 12.5055 12.3041L12.0515 14.885H9.71863L10.9431 7.93036H10.9379Z'
        fill='#4C565C'
      />
      <path
        d='M30.9947 15.2076C30.9947 15.6201 30.662 15.9586 30.2452 15.9586C29.8282 15.9586 29.4957 15.6254 29.4957 15.2076C29.4957 14.7951 29.8282 14.4566 30.2452 14.4566C30.4456 14.4566 30.6357 14.5359 30.7783 14.6787C30.9207 14.8162 31 15.0066 31 15.2076M30.8785 15.2076C30.8785 15.0383 30.8152 14.8744 30.6937 14.758C30.4561 14.5095 30.0657 14.5042 29.8176 14.7422C29.8176 14.7422 29.8071 14.7527 29.8018 14.758C29.559 15.0119 29.559 15.4085 29.8018 15.6624C30.0393 15.911 30.435 15.911 30.6831 15.673C30.6831 15.673 30.6884 15.6677 30.6937 15.6624C30.8152 15.5461 30.8838 15.3821 30.8785 15.2129M30.5618 15.6148H30.4298L30.2399 15.2816H30.1184V15.6148H30.0024V14.7951H30.2821C30.3507 14.7951 30.414 14.8215 30.4669 14.8638C30.5144 14.9061 30.5408 14.9749 30.5408 15.0383C30.5408 15.1441 30.4722 15.2446 30.3665 15.2657L30.5618 15.6148ZM30.4245 15.0436C30.4245 15.0066 30.4087 14.9643 30.3823 14.9378C30.3507 14.9114 30.3138 14.8955 30.2716 14.8955H30.1184V15.1811H30.2716C30.3138 15.1811 30.3507 15.1705 30.3823 15.1388C30.4087 15.1124 30.4245 15.0754 30.4245 15.0383'
        fill='#4C565C'
      />
      <path
        d='M28.8253 7.93036C28.4348 7.93036 28.0758 8.1472 27.907 8.49624L26.2127 12.3834L25.6004 8.49624C25.5529 8.1472 25.2415 7.89863 24.8932 7.93036H22.7502L24.587 14.3931C24.624 14.5253 24.6293 14.6628 24.6029 14.8003C24.492 15.3504 24.017 15.7576 23.4522 15.7787H22.2488C21.9427 15.7787 21.7421 15.9691 21.6418 16.3975L21.3727 18H23.4892C24.8826 17.963 26.1388 17.1591 26.7563 15.9057L30.9947 7.93565H28.8253V7.93036Z'
        fill='#4C565C'
      />
    </svg>
  )
})
